import SectionHeading from "@/pages/home/components/SectionHeading";
import { guideSteps, guideTips, stats } from "@/mocks/doumanData";

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="使用教程"
          title="四步上手：从找到入口到开始阅读"
          desc="如果你是第一次使用，按照下面四步走一遍，基本就能顺利进入并开始阅读。整个过程不需要任何额外配置。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {guideSteps.map((step) => (
            <article key={step.no} className="relative p-6 rounded-lg bg-background-100 border border-background-200">
              <span className="absolute top-5 right-5 font-heading font-black text-3xl text-background-300">
                {step.no}
              </span>
              <span className="w-11 h-11 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className={`${step.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <aside className="lg:col-span-2 p-6 md:p-7 rounded-lg bg-accent-50 border border-accent-200">
            <h3 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
              <i className="ri-file-list-3-line text-accent-700" aria-hidden="true"></i>
              新手常见的三个小建议
            </h3>
            <ul className="mt-5 space-y-4">
              {guideTips.map((tip) => (
                <li key={tip} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700">
                  <span className="shrink-0 w-6 h-6 rounded-full bg-accent-500 text-background-50 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-sm" aria-hidden="true"></i>
                  </span>
                  <span>{tip}</span>
                </li>
              ))}
            </ul>
          </aside>

          <div className="p-6 md:p-7 rounded-lg bg-foreground-950 text-background-50">
            <h3 className="font-heading font-bold text-lg flex items-center gap-2">
              <i className="ri-bar-chart-box-line text-secondary-400" aria-hidden="true"></i>
              本导航页收录一览
            </h3>
            <div className="mt-5 grid grid-cols-2 gap-4">
              {stats.map((item) => (
                <div key={item.label} className="p-4 rounded-lg bg-background-50/10 border border-background-50/15">
                  <i className={`${item.icon} text-lg text-secondary-400`} aria-hidden="true"></i>
                  <p className="mt-2 font-heading font-black text-xl text-background-50">{item.value}</p>
                  <p className="text-xs text-background-100">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}